// AUTO-GENERATED SQL Builder (V40 Final) for Booking
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingSql {
  private ast = new SqlAst('Booking', 'booking');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingNo: SqlField;
  public customerId: SqlField;
  public resellerVendorId: SqlField;
  public eventDate: SqlField;
  public eventTime: SqlField;
  public eventSessionId: SqlField;
  public venueName: SqlField;
  public venueAddress: SqlField;
  public totalAmount: SqlField;
  public protectionFee: SqlField;
  public depositPercent: SqlField;
  public balanceDueDate: SqlField;
  public isResale: SqlField;
  public status: SqlField;
  public notes: SqlField;
  public origin: SqlField;
  public guests: SqlField;
  public primaryOfferingId: SqlField;
  public holdExpiresOn: SqlField;
  public depositAmount: SqlField;
  public protectionPct: SqlField;
  public isInvoiceVoid: SqlField;
  public completionStatus: SqlField;
  public completionRequestedDate: SqlField;
  public requestedDate: SqlField;
  public completionDecidedDate: SqlField;
  public contactName: SqlField;
  public contactPhone: SqlField;
  public contactEmail: SqlField;
  public createdByUser: SqlNavHybrid;
  public customer: SqlNavHybrid;
  public eventSession: SqlNavHybrid;
  public primaryOffering: SqlNavHybrid;
  public resellerVendor: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public bookingAdjustmentList: SqlNavHybrid;
  public bookingCancellationList: SqlNavHybrid;
  public bookingChangeProposalList: SqlNavHybrid;
  public bookingCompletionProofList: SqlNavHybrid;
  public bookingDishSelectionList: SqlNavHybrid;
  public bookingDisputeList: SqlNavHybrid;
  public bookingFeeRateList: SqlNavHybrid;
  public bookingItemSelectionList: SqlNavHybrid;
  public bookingMilestoneList: SqlNavHybrid;
  public bookingPackageList: SqlNavHybrid;
  public bookingPartnerChangeList: SqlNavHybrid;
  public bookingScheduleList: SqlNavHybrid;
  public bookingSlotSelectionList: SqlNavHybrid;
  public earlyReleaseList: SqlNavHybrid;
  public invoiceList: SqlNavHybrid;
  public ledgerEntryList: SqlNavHybrid;
  public notificationList: SqlNavHybrid;
  public partnerApprovalList: SqlNavHybrid;
  public paymentList: SqlNavHybrid;
  public reviewList: SqlNavHybrid;
  public weddingCardList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('booking', 'guid', '', 'id', 'booking_guid');
    this.bookingNo = new SqlField('booking', 'bookingNo', '', 'id', 'booking_bookingNo');
    this.customerId = new SqlField('booking', 'customerId', 'customer', 'id', 'booking_customer');
    this.resellerVendorId = new SqlField('booking', 'resellerVendorId', '', 'id', 'booking_resellerVendor');
    this.eventDate = new SqlField('booking', 'eventDate', '', 'id', 'booking_eventDate');
    this.eventTime = new SqlField('booking', 'eventTime', '', 'id', 'booking_eventTime');
    this.eventSessionId = new SqlField('booking', 'eventSessionId', 'eventSession', 'id', 'booking_eventSession');
    this.venueName = new SqlField('booking', 'venueName', '', 'id', 'booking_venueName');
    this.venueAddress = new SqlField('booking', 'venueAddress', '', 'id', 'booking_venueAddress');
    this.totalAmount = new SqlField('booking', 'totalAmount', '', 'id', 'booking_totalAmount');
    this.protectionFee = new SqlField('booking', 'protectionFee', '', 'id', 'booking_protectionFee');
    this.depositPercent = new SqlField('booking', 'depositPercent', '', 'id', 'booking_depositPercent');
    this.balanceDueDate = new SqlField('booking', 'balanceDueDate', '', 'id', 'booking_balanceDueDate');
    this.isResale = new SqlField('booking', 'isResale', '', 'id', 'booking_isResale');
    this.status = new SqlField('booking', 'status', '', 'id', 'booking_status');
    this.notes = new SqlField('booking', 'notes', '', 'id', 'booking_notes');
    this.origin = new SqlField('booking', 'origin', '', 'id', 'booking_origin');
    this.guests = new SqlField('booking', 'guests', '', 'id', 'booking_guests');
    this.primaryOfferingId = new SqlField('booking', 'primaryOfferingId', '', 'id', 'booking_primaryOffering');
    this.holdExpiresOn = new SqlField('booking', 'holdExpiresOn', '', 'id', 'booking_holdExpiresOn');
    this.depositAmount = new SqlField('booking', 'depositAmount', '', 'id', 'booking_depositAmount');
    this.protectionPct = new SqlField('booking', 'protectionPct', '', 'id', 'booking_protectionPct');
    this.isInvoiceVoid = new SqlField('booking', 'isInvoiceVoid', '', 'id', 'booking_isInvoiceVoid');
    this.completionStatus = new SqlField('booking', 'completionStatus', '', 'id', 'booking_completionStatus');
    this.completionRequestedDate = new SqlField('booking', 'completionRequestedDate', '', 'id', 'booking_completionRequestedDate');
    this.requestedDate = new SqlField('booking', 'requestedDate', '', 'id', 'booking_requestedDate');
    this.completionDecidedDate = new SqlField('booking', 'completionDecidedDate', '', 'id', 'booking_completionDecidedDate');
    this.contactName = new SqlField('booking', 'contactName', '', 'id', 'booking_contactName');
    this.contactPhone = new SqlField('booking', 'contactPhone', '', 'id', 'booking_contactPhone');
    this.contactEmail = new SqlField('booking', 'contactEmail', '', 'id', 'booking_contactEmail');
    this.createdByUser = createNavHybrid('booking', 'booking_createdByUser', 'User');
    this.customer = createNavHybrid('booking', 'booking_customer', 'Customer');
    this.eventSession = createNavHybrid('booking', 'booking_eventSession', 'EventSession');
    this.primaryOffering = createNavHybrid('booking', 'booking_primaryOffering', 'Offering');
    this.resellerVendor = createNavHybrid('booking', 'booking_resellerVendor', 'Vendor');
    this.updatedByUser = createNavHybrid('booking', 'booking_updatedByUser', 'User');
    this.bookingAdjustmentList = createNavHybrid('booking', 'booking_bookingAdjustmentList', 'BookingAdjustment');
    this.bookingCancellationList = createNavHybrid('booking', 'booking_bookingCancellationList', 'BookingCancellation');
    this.bookingChangeProposalList = createNavHybrid('booking', 'booking_bookingChangeProposalList', 'BookingChangeProposal');
    this.bookingCompletionProofList = createNavHybrid('booking', 'booking_bookingCompletionProofList', 'BookingCompletionProof');
    this.bookingDishSelectionList = createNavHybrid('booking', 'booking_bookingDishSelectionList', 'BookingDishSelection');
    this.bookingDisputeList = createNavHybrid('booking', 'booking_bookingDisputeList', 'BookingDispute');
    this.bookingFeeRateList = createNavHybrid('booking', 'booking_bookingFeeRateList', 'BookingFeeRate');
    this.bookingItemSelectionList = createNavHybrid('booking', 'booking_bookingItemSelectionList', 'BookingItemSelection');
    this.bookingMilestoneList = createNavHybrid('booking', 'booking_bookingMilestoneList', 'BookingMilestone');
    this.bookingPackageList = createNavHybrid('booking', 'booking_bookingPackageList', 'BookingPackage');
    this.bookingPartnerChangeList = createNavHybrid('booking', 'booking_bookingPartnerChangeList', 'BookingPartnerChange');
    this.bookingScheduleList = createNavHybrid('booking', 'booking_bookingScheduleList', 'BookingSchedule');
    this.bookingSlotSelectionList = createNavHybrid('booking', 'booking_bookingSlotSelectionList', 'BookingSlotSelection');
    this.earlyReleaseList = createNavHybrid('booking', 'booking_earlyReleaseList', 'EarlyRelease');
    this.invoiceList = createNavHybrid('booking', 'booking_invoiceList', 'Invoice');
    this.ledgerEntryList = createNavHybrid('booking', 'booking_ledgerEntryList', 'LedgerEntry');
    this.notificationList = createNavHybrid('booking', 'booking_notificationList', 'Notification');
    this.partnerApprovalList = createNavHybrid('booking', 'booking_partnerApprovalList', 'PartnerApproval');
    this.paymentList = createNavHybrid('booking', 'booking_paymentList', 'Payment');
    this.reviewList = createNavHybrid('booking', 'booking_reviewList', 'Review');
    this.weddingCardList = createNavHybrid('booking', 'booking_weddingCardList', 'WeddingCard');
    this.id = new SqlField('booking', 'id', '', 'id', 'booking_id');
    this.isDeleted = new SqlField('booking', 'isDeleted', '', 'id', 'booking_isDeleted');
    this.createdBy = new SqlField('booking', 'createdBy', '', 'id', 'booking_createdBy');
    this.createdDate = new SqlField('booking', 'createdDate', '', 'id', 'booking_createdDate');
    this.updatedBy = new SqlField('booking', 'updatedBy', '', 'id', 'booking_updatedBy');
    this.updatedDate = new SqlField('booking', 'updatedDate', '', 'id', 'booking_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
